import { useInjectCampaign } from '@/hooks/use_campaign';
import { UseActionExecuteType } from '@/models/action_base';
import { openExternalUrl } from '@/utils/open_external_url';

import { useState } from './use_state';

/**
 * キャンペーン情報を取得して、データをローカルに保持する
 */
export function useActionOpenExternalXShare(): UseActionExecuteType {
  const state = useState();
  const campaign = useInjectCampaign();

  return async () => {
    const textWithUuidParam = `${campaign.xShareText}\n${campaign.xShareUrl}?u=${state.value.xUuid}`;
    const encodedText = encodeURIComponent(textWithUuidParam);
    const uri = `https://x.com/intent/tweet?text=${encodedText}`;
    openExternalUrl(uri, false); //昨年同様同じタブで開く
    return false;
  };
}
